import { mediaQuerySp } from "../../templates/front.js";
import Swiper from "swiper";
import { Autoplay, Pagination } from "swiper/modules";
import CountAction from "@/js/plugins/CountAction";
import { countUpAction } from "@/js/helpers";
import "swiper/css";
import "swiper/css/pagination";
import searchListMain, { parentChildCheckbox } from "@/js/components/others/_search-list.js";

const createSwiper = (dom, options) => {
     return new Swiper(dom, options);
}

const destroySwiper = (swiper) => {
     if (swiper) {
          swiper.destroy(true, true);
          swiper = null;
     }
     return swiper;
}

const setAreaSearchCountAction = (type) => {
     const areaSearchCountAction = new CountAction(document.querySelector(`.pg-area-search-area-list__block[data-mode="${type}"] [data-pickup-search]`));
     areaSearchCountAction.on('countChange', (e) => {
          const target = document.querySelector('.pg-area-search [data-pickup-count]');
          countUpAction(target, e.count);
          if (e.count == 0) {
               document.querySelector('.pg-area-search-result__count').dataset.empty = '';
               document.querySelectorAll('.pg-area-search-result__buttons button').forEach(button => button.setAttribute('disabled', ''));
          } else {
               delete document.querySelector('.pg-area-search-result__count').dataset.empty;
               document.querySelectorAll('.pg-area-search-result__buttons button').forEach(button => button.removeAttribute('disabled'));
          }
          parentChildCheckbox();
     });
}

const setStaffSwiper = () => {
     const staffSwipers = [];
     for (let i = 1; i <= 4; i++) {
          staffSwipers.push(createSwiper(`.pg-staff-swiper${i}`, {
               modules: [Autoplay],
               loop: true,
               slidesPerView: 3,
               speed: 6000,
               direction: 'vertical',
               spaceBetween: 4,
               allowTouchMove: false,
               autoplay: {
                    delay: 0,
                    reverseDirection: i % 2 === 0 ? true : false,
               },
               breakpoints: {
                    640: {
                         slidesPerView: 2,
                         spaceBetween: 12,
                    },
                    1024: {
                         slidesPerView: 1.2,
                         spaceBetween: 12,
                    }
               }
          }));
     }
}

const setBannerSwiper = () => {
     const bannerSlide = document.querySelector('.pg-banner__slide');
     if (!bannerSlide) return null;

     const wrapper = bannerSlide.querySelector('.swiper-wrapper');
     const originalSlides = Array.from(wrapper.querySelectorAll('.swiper-slide'));
     const originalCount = originalSlides.length;

     if (originalCount === 0) return null;

     if (originalCount < 7) {
          const fragment = document.createDocumentFragment();
          const repeatCount = Math.min(2, Math.ceil(7 / originalCount));

          for (let i = 1; i < repeatCount; i++) {
               originalSlides.forEach(slide => {
                    fragment.appendChild(slide.cloneNode(true));
               });
          }
          wrapper.appendChild(fragment);
     }

     let paginationBullets = [];

     return createSwiper('.pg-banner__slide', {
          modules: [Autoplay, Pagination],
          loop: true,
          slidesPerView: "auto",
          spaceBetween: 20,
          speed: 600,
          pagination: {
               el: '.pg-banner__slide .swiper-pagination',
               clickable: true,
               renderBullet: function (index, className) {
                    if (index < originalCount) {
                         return '<span class="' + className + '"></span>';
                    }
                    return '';
               },
          },
          autoplay: {
               delay: 3000,
               disableOnInteraction: false,
               waitForTransition: false,
          },
          on: {
               init: function() {
                    paginationBullets = Array.from(document.querySelectorAll('.pg-banner__slide .swiper-pagination-bullet'));
               },
               slideChange: function() {
                    if (paginationBullets.length === 0) return;

                    const realIndex = this.realIndex % originalCount;
                    const activeClass = 'swiper-pagination-bullet-active';

                    const currentActive = document.querySelector(`.pg-banner__slide .${activeClass}`);
                    if (currentActive) currentActive.classList.remove(activeClass);

                    if (paginationBullets[realIndex]) {
                         paginationBullets[realIndex].classList.add(activeClass);
                    }
               }
          }
     });
};

const setMainVisualVideo = () => {
     const video = document.querySelector('.pg-main-visual__image video');
     if (!video) return;

     const isSp = window.matchMedia('(max-width: 767px)').matches;
     const { srcWebmPc, srcMp4Pc, srcWebmSp, srcMp4Sp } = video.dataset;
     const webm = isSp ? srcWebmSp : srcWebmPc;
     const mp4 = isSp ? srcMp4Sp : srcMp4Pc;

     video.innerHTML = `<source src="${webm}" type="video/webm"><source src="${mp4}" type="video/mp4">`;
     video.load();
     video.play().catch(() => {});
};

const main = () => {
     if (document.querySelector('#page-home') === null) return;
     setMainVisualVideo();
     let salesSwiper = null;
     let bannerSwiper = null;
     const handleMediaQuery = (event) => {
          if (event.matches) {
               salesSwiper = createSwiper('.pg-sales__content', {
                    modules: [Autoplay, Pagination],
                    loop: true,
                    slidesPerView: 1.2,
                    centeredSlides: true,
                    spaceBetween: 16,
                    pagination: {
                         el: '.swiper-pagination',
                         clickable: true,
                    },
               });
               destroySwiper(bannerSwiper);
          } else {
               destroySwiper(salesSwiper);
               bannerSwiper = setBannerSwiper();
               console.log(bannerSwiper);
          }
     }

     const salesSection = document.querySelector('.pg-sales');
     if (salesSection) {
          salesSection.addEventListener('onLoadContents', () => {
               handleMediaQuery(mediaQuerySp);
          });
     }

     handleMediaQuery(mediaQuerySp);
     mediaQuerySp.addEventListener("change", handleMediaQuery);

     // Intersection Observerで.pg-messageが画面外に出るまで.pg-main-visual__imageを固定
     const target = document.querySelector('.pg-message');
     const fixedElement = document.querySelector('.pg-main-visual__image');

     if (target && fixedElement) {
          const observer = new IntersectionObserver((entries) => {
               entries.forEach(entry => {
                    if (!entry.isIntersecting) {
                         delete fixedElement.dataset.isFixed;
                    } else {
                         fixedElement.dataset.isFixed = '';
                    }
               });
          }, { threshold: 0 });
          observer.observe(target);
     }

     // 少し下にスクロールしたら追従バナーをふわっと表示／フッター（画面下）に来たら非表示
     const fixedBanner = document.querySelector('.pg-fixed-banner');
     if (fixedBanner) {
          const footer = document.querySelector('footer');
          let footerVisible = false;

          const updateFixedBanner = () => {
               const scrolledEnough = window.scrollY > window.innerHeight * 0.5;
               if (scrolledEnough && !footerVisible) {
                    fixedBanner.dataset.isShow = '';
               } else {
                    delete fixedBanner.dataset.isShow;
               }
          };

          if (footer) {
               const footerObserver = new IntersectionObserver((entries) => {
                    footerVisible = entries[0].isIntersecting;
                    updateFixedBanner();
               }, { threshold: 0 });
               footerObserver.observe(footer);
          }

          updateFixedBanner();
          window.addEventListener('scroll', updateFixedBanner, { passive: true });
          window.addEventListener('resize', updateFixedBanner, { passive: true });
     }

     document.querySelector('.pg-area-search').addEventListener('onLoadContents', () => {
          document.querySelector('.pg-area-search__type select').addEventListener('change', (e) => {
               const selectedType = e.currentTarget.value;
               console.log(selectedType);
               document.querySelector('.pg-area-search-result__count').dataset.empty = '';
               document.querySelectorAll('.pg-area-search-result__buttons button').forEach(button => button.setAttribute('disabled', ''));
               document.querySelector('.pg-area-search-result__count [data-pickup-count]').innerText = '0';
               document.querySelectorAll('.pg-area-search-area-list__block input[type="checkbox"]').forEach(checkbox => {
                    checkbox.checked = false;
               });
               document.querySelectorAll('.pg-area-search-result__buttons button').forEach(button => button.setAttribute('form', `area-search-form-${selectedType}`));
               document.querySelectorAll('.pg-area-search-area-list__block').forEach(block => {
                    if (block.dataset.mode === selectedType) {
                         block.dataset.isShow = '';
                    } else {
                         delete block.dataset.isShow;
                    }
               });
          });
          document.querySelector('.pg-area-search__type select').dispatchEvent(new Event('change'));

          ["mansion", "land", "house"].forEach(type => {
               setAreaSearchCountAction(type);
          });

          document.querySelector('.pg-area-search').querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
               checkbox.addEventListener('change', () => {
                    setTimeout(() => {
                         const count = document.querySelector('.pg-area-search').querySelectorAll('input[type="checkbox"]:checked').length;
                         console.log(count);
                         const target = document.querySelector('.pg-area-search__result');
                         if (count === 0) {
                              delete target.dataset.fixed;
                         } else {
                              target.dataset.fixed = '';
                         }
                    }, 100);
               });
          });
          searchListMain();
     });

     setStaffSwiper();
}
export default main;
